export class Partners {
    static moduleName = 'partners';
    static moduleEntityName = 'partnersEntity';
    static listTitle = 'Список партнерских предложений';
    static createTitle = 'Добавление нового партнерского предложения';
    static editTitle = 'Редактирование партнерского предложения';
    static apiPrefix = 'partners';
}